import type { Variant } from '../gameTypes.js';
import type { PianoChart } from '../pianoChart.js';
import { PALETTE_GLACIER } from '../builtinPulseMaps/palettes.js';
import { buildBuiltinAudio } from '../builtinPulseMaps/audioFromOnsets.js';
import audioOnsets from '../circlesBuiltinMaps/audio/blank.onsets.json' with { type: 'json' };
import { pianoVariantsFromSpec } from './pianoFromOnsets.js';

/**
 * Blank — Disfigure (NCS). 140 BPM classic NCS melodic dubstep with
 * a snare backbeat. Mid-tier challenge — the syncopated snare gives
 * the lane assignment a natural left-right sway.
 *
 * Synthesised from the Circles onset analysis. See the header doc
 * on {@link import('./01-on-and-on.js').ON_AND_ON_PIANO_VARIANTS}
 * for the curated-MIDI upgrade path.
 */
export const BLANK_PIANO_VARIANTS: Record<Variant, PianoChart> = pianoVariantsFromSpec({
  baseSlug: 'blank',
  baseTitle: 'Blank',
  description:
    "Disfigure's classic NCS melodic dubstep. Snare backbeat and a melodic lead — comfortable mid-tier challenge.",
  difficulty: 3,
  totalBeats: 143,
  palette: PALETTE_GLACIER,
  audio: buildBuiltinAudio({
    src: '/audio/circles/blank.mp3',
    attribution: '"Blank" by Disfigure [NCS Release] - https://ncs.io/Blank',
    data: audioOnsets,
  }),
  onsets: audioOnsets,
  sections: [
    {
      startBeat: 0,
      endBeat: 143,
      selectOpts: { kinds: ['lead', 'snare'], minIntensity: 0.06, minSpacing: 0.5 },
    },
  ],
});
